import { render } from "./view-stock-adjustment-report.vue?vue&type=template&id=e4f2db9c"
import script from "./view-stock-adjustment-report.vue?vue&type=script&lang=js"
export * from "./view-stock-adjustment-report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__